import { config, gameState } from '@js/state';

var attempts = 0;
var hintOn = false;

var finalRouteMap_Q3 = [];

var entryPoint = [0, 0];

var selectedCount_Q3 = 0;

var routeMapSet_Q3 = 1;

var newPointDistanceQ3 = 0;

var plantArrayQ3 = [[], [], [], [], [], [], [], [], [], []];

var plantLeftArrayQ3 = [[], [], [], [], [], [], [], [], [], []];

var leftEntrance_Q3 = new Phaser.Geom.Point(434, -200);

var leftQ3_p1 = new Phaser.Geom.Point(319, 233);
var leftQ3_p2 = new Phaser.Geom.Point(200, 437);

// var leftQ3_p6 = new Phaser.Geom.Point(40, 203);
// var leftQ3_p7 = new Phaser.Geom.Point(40, 326);
// var leftQ3_p8 = new Phaser.Geom.Point(120, 326);
// var leftQ3_p9 = new Phaser.Geom.Point(200, 326);

var leftExitWay_Q3 = new Phaser.Geom.Point(200, 900);

var leftFinalRouteMap_Q3 = [leftEntrance_Q3, leftQ3_p1, leftQ3_p2, leftExitWay_Q3];

var leftRouteMapSet_Q3 = 1;

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

var entrance_Q3 = new Phaser.Geom.Point(0, 0);

var exitWay_Q3 = new Phaser.Geom.Point(0, 0);

var Q3_p2 = new Phaser.Geom.Point(915, 279);
var Q3_p1 = new Phaser.Geom.Point(993, 279);
var Q3_p4 = new Phaser.Geom.Point(844, 392);
var Q3_p3 = new Phaser.Geom.Point(1062, 392);
var Q3_p6 = new Phaser.Geom.Point(873, 471);
var Q3_p5 = new Phaser.Geom.Point(1043, 471);

export default class GameSceneQ3 extends Phaser.Scene {
  constructor() {
    super({
      key: "GameSceneQ3",
    });
  }

  preload() {
    this.load.image("BGQ3", "assets/Q3/BGQ3.png");

    this.load.image("D_BGQ3", "assets/Q3/D_BGQ3.png");
    this.load.image("L_curbQ3", "assets/Q3/L_curbQ3.png");

    this.load.image("curbQ3", "assets/Q3/curbQ3.png");
    this.load.image("rightPlotQ3", "assets/Q3/rightPlotQ3.png");

    this.load.image("whiteBoxQ3img_1", "assets/Q3/whiteBoxQ3img_1.png");
    this.load.image("whiteBoxQ3img_2", "assets/Q3/whiteBoxQ3img_2.png");
    this.load.image("whiteBoxQ3img_3", "assets/Q3/whiteBoxQ3img_3.png");

    this.load.image("hitBoxQ3img_1", "assets/Q3/hitBoxQ3img_1.png");
    this.load.image("hitBoxQ3img_2", "assets/Q3/hitBoxQ3img_2.png");
    this.load.image("hitBoxQ3img_3", "assets/Q3/hitBoxQ3img_3.png");

    this.load.image("whiteBoxQ3img_4", "assets/Q3/whiteBoxQ3img_4.png");
    this.load.image("whiteBoxQ3img_5", "assets/Q3/whiteBoxQ3img_5.png");
    this.load.image("whiteBoxQ3img_6", "assets/Q3/whiteBoxQ3img_6.png");

    this.load.image("hitBoxQ3img_4", "assets/Q3/hitBoxQ3img_4.png");
    this.load.image("hitBoxQ3img_5", "assets/Q3/hitBoxQ3img_5.png");
    this.load.image("hitBoxQ3img_6", "assets/Q3/hitBoxQ3img_6.png");

    this.load.image("leftGreyBoxQ3", "assets/Q3/leftGreyBoxQ3.png");
  }

  create() {
    this.cameras.main.fadeIn(1500, 255, 255, 255);

    config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.02);
    config.audio.bgaudio.play();

    config.audio.hintAlert = this.sound.add("hintAlert").setVolume(0.05);
    config.audio.hover = this.sound.add("hover").setVolume(0.05);
    config.audio.correctAnswer = this.sound.add("correctAnswer").setVolume(0.05);
    config.audio.wrongAnswer = this.sound.add("wrongAnswer").setVolume(0.05);

    config.audio.waterCan = this.sound.add("waterCan").setVolume(0.05);
    config.audio.watering = this.sound.add("watering").setVolume(0.05);

    config.audio.sunShining = this.sound.add("sunShining").setVolume(0.05);
    config.audio.flowerBlossoming = this.sound.add("flowerBlossoming").setVolume(0.05);

    ///audio end

    this.BGQ3 = this.add.sprite(config.width / 2, config.height / 2, "D_BGQ3");

    this.progressBar = this.add.sprite(497.81, -12.89, "progressBar").setOrigin(0);

    this.correctGreen_1 = this.add.sprite(510, 17, "correctGreen").setOrigin(0).setDepth(0);

    this.deselectText = this.add
      .sprite(config.width / 2, config.height / 2, "deselectText")
      .setDepth(1)
      .setVisible(false);
    this.hand = this.add.sprite(783, 179, "hand").setOrigin(0.2, 0.2).setVisible(false).setDepth(6);
    this.correctGreen_2 = this.add.sprite(552, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_3 = this.add.sprite(594, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_4 = this.add.sprite(636, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_5 = this.add.sprite(678, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_6 = this.add.sprite(719.2, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);

    this.scoreRefresh();

    this.addWaterButton = this.add.sprite(860, 624, "addWaterButton").setInteractive({ cursor: "pointer" }).setOrigin(0).setDepth(2);

    this.curbQ3 = this.add.sprite(688, 76, "L_curbQ3").setOrigin(0).setDepth(2);
    this.add.sprite(689, 115, "rightPlotQ3").setOrigin(0).setDepth(2);

    // this.hitBoxQ3_1 = this.add.sprite(951.5,116, "hitBoxQ3img_1").setInteractive(this.input.makePixelPerfect(70)).setOrigin(0).setAlpha(0.1);
    // this.hitBoxQ3_2 = this.add.sprite(838.5,116, "hitBoxQ3img_1").setInteractive(this.input.makePixelPerfect(70)).setOrigin(0).setAlpha(0.5).setFlipX(true).setVisible(true).setTint(0xff0000);
    // this.hitBoxQ3_3 = this.add.sprite(951.5,313, "hitBoxQ3img_2").setInteractive(this.input.makePixelPerfect(70)).setOrigin(0).setAlpha(0.1);
    // this.hitBoxQ3_4 = this.add.sprite(725.5,313, "hitBoxQ3img_2").setInteractive(this.input.makePixelPerfect(70)).setOrigin(0).setAlpha(0.75).setFlipX(true).setVisible(true).setTint(0xff0000);
    // this.hitBoxQ3_5 = this.add.sprite(951.5,380, "hitBoxQ3img_3").setInteractive(this.input.makePixelPerfect(70)).setOrigin(0).setAlpha(0.1);
    // this.hitBoxQ3_6 = this.add.sprite(725.5,380, "hitBoxQ3img_3").setInteractive(this.input.makePixelPerfect(70)).setOrigin(0).setAlpha(1).setFlipX(true).setVisible(true).setTint(0xff0000);

    // this.whiteBoxQ3_1 = this.add.sprite(951.5,116, "whiteBoxQ3img_1").setOrigin(0).setVisible(false);
    // this.whiteBoxQ3_2 = this.add.sprite(838.5,116, "whiteBoxQ3img_1").setOrigin(0).setVisible(false).setFlipX(true);
    // this.whiteBoxQ3_3 = this.add.sprite(951.5,313, "whiteBoxQ3img_2").setOrigin(0).setVisible(false);
    // this.whiteBoxQ3_4 = this.add.sprite(725.5,313, "whiteBoxQ3img_2").setOrigin(0).setVisible(false).setFlipX(true);
    // this.whiteBoxQ3_5 = this.add.sprite(951.5,379, "whiteBoxQ3img_3").setOrigin(0).setVisible(false);
    // this.whiteBoxQ3_6 = this.add.sprite(727,379, "whiteBoxQ3img_3").setOrigin(0).setVisible(false).setFlipX(true);

    this.hitBoxQ3_1 = this.add.sprite(951.5, 116, "hitBoxQ3img_1").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ3_2 = this.add.sprite(951.5, 116, "hitBoxQ3img_6").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(1, 0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ3_3 = this.add.sprite(951.5, 313, "hitBoxQ3img_2").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ3_4 = this.add.sprite(950.5, 313, "hitBoxQ3img_5").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(1, 0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ3_5 = this.add.sprite(951.5, 380, "hitBoxQ3img_3").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ3_6 = this.add.sprite(951.5, 380, "hitBoxQ3img_4").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(1, 0).setAlpha(0.1).setDepth(2);

    this.whiteBoxQ3_1 = this.add.sprite(951.5, 116, "whiteBoxQ3img_1").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ3_2 = this.add.sprite(951.5, 116, "whiteBoxQ3img_6").setOrigin(1, 0).setVisible(false).setDepth(2);
    this.whiteBoxQ3_3 = this.add.sprite(951.5, 313, "whiteBoxQ3img_2").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ3_4 = this.add.sprite(950.5, 313, "whiteBoxQ3img_5").setOrigin(1, 0).setVisible(false).setDepth(2);
    this.whiteBoxQ3_5 = this.add.sprite(951.5, 379, "whiteBoxQ3img_3").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ3_6 = this.add.sprite(951.5, 379, "whiteBoxQ3img_4").setOrigin(1, 0).setVisible(false).setDepth(2);

    ///

    this.leftGreyBoxQ3 = this.add.sprite(74, 114, "leftGreyBoxQ3").setOrigin(0).setVisible(false);

    this.anims.create({
      key: "sunrise",
      frames: this.anims.generateFrameNames("sunAnim", {
        start: 0,
        end: 348,
        zeroPad: 0,
        prefix: "sunAnim",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });
    this.anims.create({
      key: "shake",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 1,
        end: 27,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 0,
        end: 0,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    // this.Q3_ans = this.add.sprite(654.14,474.2, "qnBoard").setOrigin(0);

    this.Q3_ans = this.add.sprite(0, 0, "wrongPlacardAnim").setOrigin(0).setDepth(2);

    this.Q3_qn = this.add.sprite(20.14, 473.2, "qnBoard").setOrigin(0);

    this.sun = this.add.sprite(0, 0, "sunAnim").setOrigin(0).setDepth(8);

    this.leftLine = this.add.sprite(55, 547, "line").setOrigin(0);
    this.rightLine = this.add.sprite(691, 548, "line").setOrigin(0).setDepth(2);

    this.inputWindow = this.add.sprite(690, 500, "inputWindow").setOrigin(0);

    this.Q3_leftNr = this.add.text(78, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true);
    this.Q3_leftDr = this.add.text(78, 578, "4", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5);

    this.Q3_input = this.add.text(715, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true).setDepth(2);
    this.Q3_rightDr = this.add.text(715, 578, "6", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setDepth(2);

    this.can = this.add.sprite(-200, -200, "wateringCanAnim").setOrigin(0.8, 0.9).setDepth(6);
    this.add.sprite(692.22, 646.37, "grass").setOrigin(0).setDepth(2);

    this.anims.create({
      key: "floweringQ3",
      frames: this.anims.generateFrameNames("flowering4Anim", {
        start: 30,
        end: 75,
        zeroPad: 0,
        prefix: "Flower",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.hint = this.add.sprite(255, 552, "hint_1").setScale(0.8).setVisible(false).setDepth(7);

    this.closeHintButton = this.add.sprite(445, 450, "closeHint").setVisible(false).setDepth(7).setInteractive({ cursor: "pointer" });

    // this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7).setInteractive({ cursor: "pointer" });

    this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7);

    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idlehint",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false);

    this.handleHintButton();
    // this.hitboxClickAndHoverHandle();
    // this.handleAddWaterButton();

    this.waterPlantOnLeftQ3();

    // var graphics = this.add.graphics();

    // graphics.fillStyle(0xff0000, 1);

    // graphics.fillCircle(Q3_p1.x, Q3_p1.y, 4);
    // graphics.fillCircle(Q3_p2.x, Q3_p2.y, 4);
    // graphics.fillCircle(Q3_p3.x, Q3_p3.y, 4);
    // graphics.fillCircle(Q3_p4.x, Q3_p4.y, 4);
    // graphics.fillCircle(Q3_p5.x, Q3_p5.y, 4);
    // graphics.fillCircle(Q3_p6.x, Q3_p6.y, 4);
  }

  showDeselect() {
    if (selectedCount_Q3 >= 3) {
      if (!gameState.firstMistake) {
        this.deselectText.setVisible(true);

        this.hand.setVisible(true);
        this.tweens.add({
          targets: this.hand,
          duration: 500,
          ease: "easeInOutSine",
          // delay: 500,
          yoyo: true,
          // x: {from:783, to:1069},
          // y: {from:179, to:640},
          scale: { from: 1, to: 0.8 },
          loop: -1,
        });

        this.hand.setPosition(finalRouteMap_Q3[0].x, finalRouteMap_Q3[0].y);
      }

      gameState.firstMistake = true;
    }
  }

  hideDeselect() {
    this.deselectText.setVisible(false);
    this.hand.setVisible(false);
  }

  waterPlantOnLeftQ3() {
    this.time.delayedCall(
      1500,
      () => {
        this.leftGreyBoxQ3.setVisible(true);

        this.moveCanInitial(leftFinalRouteMap_Q3[0].x, leftFinalRouteMap_Q3[0].y, leftFinalRouteMap_Q3[1].x, leftFinalRouteMap_Q3[1].y);
      },
      [],
      this
    );
  }

  startQuestionQ3() {
    //>//>>>hidden_console.log("startQ3");

    this.hitboxClickAndHoverHandle();
    this.handleAddWaterButton();
  }

  toggleHit(hitboxname, xcode, ycode) {
    this.hideDeselect();

    if (hitboxname.alpha == 0.1) {
      hitboxname.setAlpha(1);

      this.updateRouteMap(xcode, ycode);

      selectedCount_Q3 += 1;

      this.Q3_input.setText(selectedCount_Q3);

      //>//>>>hidden_console.log(xcode +" "+ ycode);
    } else {
      hitboxname.setAlpha(0.1);

      Phaser.Utils.Array.Remove(finalRouteMap_Q3, this.getPointFromCode(xcode, ycode));

      selectedCount_Q3 -= 1;
      this.Q3_input.setText(selectedCount_Q3);
    }
  }

  moveCanInitial(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(0);
        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

        // this.createPlants(leftFinalRouteMap_Q3[leftRouteMapSet_Q3-1],leftRouteMapSet_Q3-1);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createLeftPlants(leftFinalRouteMap_Q3[leftRouteMapSet_Q3 - 1], leftRouteMapSet_Q3 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (leftRouteMapSet_Q3 < leftFinalRouteMap_Q3.length - 1) {
          this.Q3_leftNr.setText(leftRouteMapSet_Q3);

          this.moveCanInitial(leftFinalRouteMap_Q3[leftRouteMapSet_Q3].x, leftFinalRouteMap_Q3[leftRouteMapSet_Q3].y, leftFinalRouteMap_Q3[leftRouteMapSet_Q3 + 1].x, leftFinalRouteMap_Q3[leftRouteMapSet_Q3 + 1].y);

          leftRouteMapSet_Q3 = leftRouteMapSet_Q3 + 1;
          // //>//>>>hidden_console.log(leftRouteMapSet_Q3);
        } else {
          this.Q3_leftNr.setVisible(true);
          this.Q3_input.setVisible(true);

          this.startQuestionQ3();
        }
      },
      onCompleteScope: this,
    });
  }

  buddingToFlowering() {
    config.audio.flowerBlossoming.play();

    for (var k5 = 0; k5 < plantLeftArrayQ3.length; k5++) {
      for (var l5 = 0; l5 < plantLeftArrayQ3[k5].length; l5++) {
        plantLeftArrayQ3[k5][l5].setTexture("flowering4Anim").play("floweringQ3");

        //>//>>>hidden_console.log(l5 + " " + k5);
      }
    }

    // plantLeftArrayQ3[1][1].setTexture("flowering4Anim").play("floweringQ3");

    for (var k = 0; k < plantArrayQ3.length; k++) {
      for (var l = 0; l < plantArrayQ3[k].length; l++) {
        plantArrayQ3[k][l].setTexture("flowering4Anim").play("floweringQ3");
      }
    }

    // this.time.delayedCall(5000, () => {

    //   this.scene.stop("GameSceneQ3");
    //   this.scene.start('GameSceneQ4');

    // },[],this);
    this.removeClicking();
    this.changeScene();
  }

  changeScene() {
    //>//>>>hidden_console.log("ready to change scene");
    gameState.attempted = gameState.attempted + 1;

    this.tweens.add({
      targets: config.audio.bgaudio,
      volume: 0.005,
      duration: 4000,
      onComplete: () => {},
    });

    this.time.delayedCall(
      3000,
      function () {
        this.time.delayedCall(
          1000,
          function () {
            this.cameras.main.fadeOut(1000, 255, 255, 255);
          },
          [],
          this
        );

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            config.audio.bgaudio.stop();
            config.audio.flowerBlossoming.stop();
            config.audio.sunShining.stop();
            attempts = 0;

            this.wipeSceneQ3();

            if (gameState.score >= 5) {
              gameState.gameWin = true;
              this.scene.stop("GameSceneQ3");
              this.scene.start("EndScene");
            } else if (gameState.attempted == 9) {
              gameState.gameWin = false;
              this.scene.stop("GameSceneQ3");
              this.scene.start("EndScene");
            } else {
              this.scene.stop("GameSceneQ3");
              this.scene.start("GameSceneQ4");
            }

            this.cameras.main.fadeIn(1000, 255, 255, 255);

            // this.time.delayedCall(
            //   2000,
            //   function () {
            // this.cameras.main.fadeIn(1000, 255, 255, 255);
            //   },
            //   [],
            //   this
            // );
          },
          this
        );

        // if (gameState.attempted == 10) {
        //   gameState.gameWin = false;
        //   // this.scene.stop("TutorialScene");
        //   this.scene.start("EndScene");
        // }
      },
      [],
      this
    );
  }

  wipeSceneQ3() {
    attempts = 0;
    hintOn = false;

    finalRouteMap_Q3 = [];

    entryPoint = [0, 0];

    selectedCount_Q3 = 0;

    routeMapSet_Q3 = 1;

    newPointDistanceQ3 = 0;

    plantArrayQ3 = [[], [], [], [], [], [], [], [], [], [], []];

    plantLeftArrayQ3 = [[], [], [], [], [], [], [], [], [], []];

    // leftFinalRouteMap_Q3 = [leftEntrance_Q3,leftQ3_p1,leftExitWay_Q3];
    leftRouteMapSet_Q3 = 1;

    entrance_Q3.setTo(0, 0);
    exitWay_Q3.setTo(0, 0);

    Q3_p2.setTo(915, 279);
    Q3_p1.setTo(993, 279);
    Q3_p4.setTo(844, 392);
    Q3_p3.setTo(1062, 392);
    Q3_p6.setTo(873, 471);
    Q3_p5.setTo(1043, 471);
  }
  scoreRefresh() {
    //>//>>>hidden_console.log("score: " + gameState.score);
    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  updateRouteMap(xcode, ycode) {
    if (finalRouteMap_Q3.length <= 1) {
      finalRouteMap_Q3.push(this.getPointFromCode(xcode, ycode));
    } else {
      newPointDistanceQ3 = this.calculateDistance(finalRouteMap_Q3[0], this.getPointFromCode(xcode, ycode));

      //>//>>>hidden_console.log(newPointDistanceQ3);

      var routeMapLength_Q3 = finalRouteMap_Q3.length;

      for (var i = 1; i < routeMapLength_Q3; i++) {
        //>//>>>hidden_console.log(Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q3[0],finalRouteMap_Q3[i]));

        if (Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q3[0], finalRouteMap_Q3[i]) > newPointDistanceQ3) {
          if (xcode == 0 && ycode == 0) {
            finalRouteMap_Q3.insert(i, Q3_p1);
          } else if (xcode == 1 && ycode == 0) {
            finalRouteMap_Q3.insert(i, Q3_p2);
          } else if (xcode == 0 && ycode == 1) {
            finalRouteMap_Q3.insert(i, Q3_p3);
          } else if (xcode == 1 && ycode == 1) {
            finalRouteMap_Q3.insert(i, Q3_p4);
          } else if (xcode == 0 && ycode == 2) {
            finalRouteMap_Q3.insert(i, Q3_p5);
          } else if (xcode == 1 && ycode == 2) {
            finalRouteMap_Q3.insert(i, Q3_p6);
          }
        } else {
          if (xcode == 0 && ycode == 0) {
            finalRouteMap_Q3.push(Q3_p1);
          } else if (xcode == 1 && ycode == 0) {
            finalRouteMap_Q3.push(Q3_p2);
          } else if (xcode == 0 && ycode == 1) {
            finalRouteMap_Q3.push(Q3_p3);
          } else if (xcode == 1 && ycode == 1) {
            finalRouteMap_Q3.push(Q3_p4);
          } else if (xcode == 0 && ycode == 2) {
            finalRouteMap_Q3.push(Q3_p5);
          } else if (xcode == 1 && ycode == 2) {
            finalRouteMap_Q3.push(Q3_p6);
          }
        }

        break;
      }
    }

    //>//>>>hidden_console.log(finalRouteMap_Q3);
  }

  getPointFromCode(xcode, ycode) {
    if (xcode == 0 && ycode == 0) {
      return Q3_p1;
    } else if (xcode == 1 && ycode == 0) {
      return Q3_p2;
    } else if (xcode == 0 && ycode == 1) {
      return Q3_p3;
    } else if (xcode == 1 && ycode == 1) {
      return Q3_p4;
    } else if (xcode == 0 && ycode == 2) {
      return Q3_p5;
    } else if (xcode == 1 && ycode == 2) {
      return Q3_p6;
    }
  }

  scoreUpdate() {
    gameState.score = gameState.score + 1;

    //>//>>>hidden_console.log("score: " + gameState.score);

    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  handleAddWaterButton() {
    this.addWaterButton.on("pointerover", () => {
      this.addWaterButton.setTexture("hover_addWaterButton");
    });
    this.addWaterButton.on("pointerout", () => {
      this.addWaterButton.setTexture("addWaterButton");
    });
    this.addWaterButton.on("pointerup", () => {
      this.removeClicking();

      ////
      if (selectedCount_Q3 == 3) {
        config.audio.correctAnswer.play();
        this.tweens.add({
          targets: this.addWaterButton,
          duration: 500,
          ease: "easeInOutSine",
          //delay: 100,
          yoyo: false,
          // x: {from:783, to:1069},
          y: { from: 624, to: 800 },
          // scale: {from:1, to:0.8},
          loop: 0,
        });

        this.hideDeselect();

        //>2

        this.hintButton.removeInteractive();

        if (hintOn == true) {
          this.hintButton.play("pop_out");
          hintOn = false;
        }

        //gameState.score = gameState.score + 1;

        //>//>>>hidden_console.log("score: " + gameState.score);

        //<2

        this.Q3_ans.setTint(0xffffff);

        this.removeClicking();

        this.scoreUpdate();

        if (finalRouteMap_Q3[0] == Q3_p1) {
          entrance_Q3.setTo(727, -200);
        } else if (finalRouteMap_Q3[0] == Q3_p2) {
          entrance_Q3.setTo(844, -200);
        } else if (finalRouteMap_Q3[0] == Q3_p3) {
          entrance_Q3.setTo(961, -200);
        } else if (finalRouteMap_Q3[0] == Q3_p4) {
          entrance_Q3.setTo(2078, 203);
        } else if (finalRouteMap_Q3[0] == Q3_p5) {
          entrance_Q3.setTo(727, 900);
        } else if (finalRouteMap_Q3[0] == Q3_p6) {
          entrance_Q3.setTo(844, 900);
        }

        finalRouteMap_Q3.unshift(entrance_Q3);

        if (finalRouteMap_Q3[finalRouteMap_Q3.length - 1] == Q3_p1) {
          exitWay_Q3.setTo(727, -200);
        } else if (finalRouteMap_Q3[finalRouteMap_Q3.length - 1] == Q3_p2) {
          exitWay_Q3.setTo(844, -200);
        } else if (finalRouteMap_Q3[finalRouteMap_Q3.length - 1] == Q3_p3) {
          exitWay_Q3.setTo(961, -200);
        } else if (finalRouteMap_Q3[finalRouteMap_Q3.length - 1] == Q3_p4) {
          exitWay_Q3.setTo(2078, 203);
        } else if (finalRouteMap_Q3[finalRouteMap_Q3.length - 1] == Q3_p5) {
          exitWay_Q3.setTo(727, 900);
        } else if (finalRouteMap_Q3[finalRouteMap_Q3.length - 1] == Q3_p6) {
          exitWay_Q3.setTo(844, 900);
        }

        finalRouteMap_Q3.push(exitWay_Q3);

        this.moveCan(finalRouteMap_Q3[0].x, finalRouteMap_Q3[0].y, finalRouteMap_Q3[1].x, finalRouteMap_Q3[1].y);
      } else {
        config.audio.wrongAnswer.play();

        // this.Q3_ans.setTint(0xFFC2A2);

        //>3

        this.incorrectAttempt();

        this.hintButton.removeInteractive();

        //<3

        this.Q3_ans.play("shake");

        this.inputWindow.setVisible(false);

        this.rightLine.setTexture("redLine");

        this.Q3_rightDr.setFill("#C22300");
        this.Q3_input.setFill("#C22300");

        this.time.delayedCall(
          2500,
          () => {
            this.Q3_ans.play("idle");
            this.inputWindow.setVisible(true);

            this.rightLine.setTexture("line");

            this.Q3_rightDr.setFill("#2b2b2b");
            this.Q3_input.setFill("#2b2b2b");
          },
          [],
          this
        );
      }
    });
  }

  calculateDistance(target1, target2) {
    return Phaser.Math.Distance.BetweenPoints(target1, target2);
  }

  moveCan(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(100);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createPlants(finalRouteMap_Q3[routeMapSet_Q3 - 1], routeMapSet_Q3 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (routeMapSet_Q3 < finalRouteMap_Q3.length - 1) {
          this.moveCan(finalRouteMap_Q3[routeMapSet_Q3].x, finalRouteMap_Q3[routeMapSet_Q3].y, finalRouteMap_Q3[routeMapSet_Q3 + 1].x, finalRouteMap_Q3[routeMapSet_Q3 + 1].y);

          routeMapSet_Q3 = routeMapSet_Q3 + 1;
          //>//>>>hidden_console.log(routeMapSet_Q3);
        } else {
          config.audio.sunShining.play();

          this.tweens.add({
            targets: config.audio.sunShining,
            volume: 0.005,
            duration: 3000,
            onComplete: () => {},
          });

          this.sun.play("sunrise");

          this.time.delayedCall(
            3000,
            () => {
              this.buddingToFlowering();
              config.audio.sunShining.stop();
            },
            [],
            this
          );
        }
      },
      onCompleteScope: this,
    });
  }

  hitboxClickAndHoverHandle() {
    this.BGQ3.setTexture("BGQ3");
    this.curbQ3.setTexture("curbQ3");
    // this.hitBoxQ3_1.on("pointerup", () => { this.toggleHit(this.hitBoxQ3_1, 0, 0); }, this);
    // this.hitBoxQ3_2.on("pointerup", () => { this.toggleHit(this.hitBoxQ3_2, 1, 0); }, this);
    // this.hitBoxQ3_3.on("pointerup", () => { this.toggleHit(this.hitBoxQ3_3, 0, 1); }, this);
    // this.hitBoxQ3_4.on("pointerup", () => { this.toggleHit(this.hitBoxQ3_4, 1, 1); }, this);
    // this.hitBoxQ3_5.on("pointerup", () => { this.toggleHit(this.hitBoxQ3_5, 0, 2); }, this);
    // this.hitBoxQ3_6.on("pointerup", () => { this.toggleHit(this.hitBoxQ3_6, 1, 2); }, this);
    ////
    this.hitBoxQ3_1.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ3_1, 0, 0);
      },
      this
    );
    this.hitBoxQ3_2.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ3_2, 1, 0);
      },
      this
    );
    this.hitBoxQ3_3.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ3_3, 0, 1);
      },
      this
    );
    this.hitBoxQ3_4.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ3_4, 1, 1);
      },
      this
    );
    this.hitBoxQ3_5.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ3_5, 0, 2);
      },
      this
    );
    this.hitBoxQ3_6.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ3_6, 1, 2);
      },
      this
    );

    this.hitBoxQ3_1.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ3(1);
      },
      this
    );
    this.hitBoxQ3_2.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ3(2);
      },
      this
    );
    this.hitBoxQ3_3.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ3(3);
      },
      this
    );
    this.hitBoxQ3_4.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ3(4);
      },
      this
    );
    this.hitBoxQ3_5.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ3(5);
      },
      this
    );
    this.hitBoxQ3_6.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ3(6);
      },
      this
    );

    this.hitBoxQ3_1.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ3();
      },
      this
    );
    this.hitBoxQ3_2.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ3();
      },
      this
    );
    this.hitBoxQ3_3.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ3();
      },
      this
    );
    this.hitBoxQ3_4.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ3();
      },
      this
    );
    this.hitBoxQ3_5.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ3();
      },
      this
    );
    this.hitBoxQ3_6.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ3();
      },
      this
    );
  }

  //>4
  handleHintButton() {
    this.hintButton.on(
      "pointerup",
      function (pointer) {
        ////
        gameState.hints += 1;

        this.hintButton.setVisible(true);

        this.hintButton.play("idlehint");

        this.removeClicking();

        if (attempts == 1) {
          this.hint.setTexture("hint_1");

          this.overlay.setVisible(true).setDepth(6);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true).setDepth(6);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture("hint_2");
        }
      },
      this
    );

    this.closeHintButton.on(
      "pointerup",
      function (pointer) {
        this.enableClicking();

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play("pop_out");
        this.hintButton.removeInteractive();

        hintOn = false;
      },
      this
    );
  }

  incorrectAttempt() {
    // correctAnswer = false;
    this.hintButton.setVisible(false);

    // ////

    attempts += 1;

    if (attempts == 1 || attempts == 2) {
      this.showDeselect();
    } else {
      this.addWaterButton.setTexture("disable_addWaterButton");
    }
    //>//>>>hidden_console.log(attempts);

    this.time.delayedCall(
      1000,
      function () {
        if (attempts == 1 || attempts == 2) {
          hintOn = true;

          this.hintButton.setVisible(true);

          this.hintButton.play("pop");
          config.audio.hintAlert.play();

          this.time.delayedCall(
            1300,
            () => {
              this.enableClicking();

              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );

          this.time.delayedCall(
            500,
            function () {
              if (hintOn) {
                this.hintButton.play("breathe");
              }
            },
            [],
            this
          );
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      1800,
      function () {
        if (attempts == 1 || attempts == 2) {
          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );
        } else {
          this.removeClicking();
          this.changeScene();

          if (hintOn == true) {
            this.hintButton.play("pop_out");
            hintOn = false;
          }

          this.time.delayedCall(
            3300,
            function () {
              attempts = 0;
            },
            [],
            this
          );
        }
      },
      [],
      this
    );
  }

  //<4

  //>5
  enableClicking() {
    this.hitBoxQ3_1.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ3_2.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ3_3.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ3_4.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ3_5.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ3_6.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.addWaterButton.setInteractive({ cursor: "pointer" });
    this.addWaterButton.setTexture("addWaterButton");
  }

  ///<5

  removeClicking() {
    this.hitBoxQ3_1.removeInteractive();
    this.hitBoxQ3_2.removeInteractive();
    this.hitBoxQ3_3.removeInteractive();
    this.hitBoxQ3_4.removeInteractive();
    this.hitBoxQ3_5.removeInteractive();
    this.hitBoxQ3_6.removeInteractive();

    this.addWaterButton.removeInteractive();
    if (attempts == 0 || attempts == 1) {
      this.addWaterButton.setTexture("addWaterButton");
    }

    this.hintButton.removeInteractive();
  }

  showWhiteBoxQ3(position) {
    config.audio.hover.play();

    this.removeWhiteBoxQ3();
    if (position == 1) {
      this.whiteBoxQ3_1.setVisible(true);
    }
    if (position == 2) {
      this.whiteBoxQ3_2.setVisible(true);
    }
    if (position == 3) {
      this.whiteBoxQ3_3.setVisible(true);
    }
    if (position == 4) {
      this.whiteBoxQ3_4.setVisible(true);
    }
    if (position == 5) {
      this.whiteBoxQ3_5.setVisible(true);
    }
    if (position == 6) {
      this.whiteBoxQ3_6.setVisible(true);
    }
  }

  removeWhiteBoxQ3() {
    this.whiteBoxQ3_1.setVisible(false);
    this.whiteBoxQ3_2.setVisible(false);
    this.whiteBoxQ3_3.setVisible(false);
    this.whiteBoxQ3_4.setVisible(false);
    this.whiteBoxQ3_5.setVisible(false);
    this.whiteBoxQ3_6.setVisible(false);
  }

  createPlants(selectedPoint, plantSelectionCode) {
    if (selectedPoint == Q3_p2) {
      plantArrayQ3[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 20, selectedPoint.y + 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ3[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x, selectedPoint.y - 70, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q3_p1) {
      plantArrayQ3[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x + 20, selectedPoint.y + 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ3[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x, selectedPoint.y - 70, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q3_p4) {
      plantArrayQ3[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 40, selectedPoint.y + 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ3[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q3_p3) {
      plantArrayQ3[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x + 40, selectedPoint.y + 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ3[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 10, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q3_p6) {
      plantArrayQ3[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 30, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ3[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 40, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    } else if (selectedPoint == Q3_p5) {
      plantArrayQ3[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x + 30, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
      plantArrayQ3[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 40, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding")
        .setDepth(5);
    }
  }

  createLeftPlants(selectedPoint, plantSelectionCode) {
    //>//>>>hidden_console.log(plantSelectionCode);

    if (plantSelectionCode == 3) {
      plantLeftArrayQ3[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ3[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y - 70, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ3[plantSelectionCode][2] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y - 70, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ3[plantSelectionCode][3] = this.add
        .sprite(selectedPoint.x + 0, selectedPoint.y + 40, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    } else {
      plantLeftArrayQ3[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x, selectedPoint.y - 70, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ3[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y + 15, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ3[plantSelectionCode][2] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y + 15, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ3[plantSelectionCode][3] = this.add
        .sprite(selectedPoint.x + 0, selectedPoint.y, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    }
  }

  waterThePlant(flowingtime) {
    if (routeMapSet_Q3 <= selectedCount_Q3 || leftRouteMapSet_Q3 < leftFinalRouteMap_Q3.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      1000,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");
            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  update() {}
}
